import { axios } from '../../../lib/axios';


export const updateLanguageAPI = async ( language: string): Promise<void> => {
    await axios.get(`/auth/language/${language}`);
};

